export default "__VITE_ASSET__CrD44mBY__"